import { Box } from "@chakra-ui/react";


export default function FormElement(props) {
    return (
        <Box
            padding={1}
        >
            {props.children}
        </Box>
    )
}
